export default {
    title: 'Review',
    noSessions: 'No review sessions yet',
    noSessionsHint: 'Run the patent review tool to see results here',
    rules: 'rules',
    loadFailed: 'Load failed, please retry',
    view: {
        issues: 'Issues',
        patent: 'Patent Text',
    },
    filter: {
        all: 'All',
        critical: 'Critical',
        error: 'Error',
        warning: 'Warning',
        pass: 'Pass',
    },
    issue: {
        ignore: 'Ignore',
        ignored: 'Ignored',
        applied: 'Applied',
        pending: 'Pending',
        expired: 'Expired',
        ignoreSuccess: 'Ignored',
        ignoreFailed: 'Operation failed',
    },
    passCollapsed: 'Pass ({count})',
    expand: 'Expand',
    collapse: 'Collapse',
    uncategorized: 'Uncategorized',
    noIssuesInSection: 'No issues in this section',
    patent: {
        loading: 'Loading...',
        loadError: 'Load failed, please retry',
        noContent: 'No content available',
        specification: 'Specification',
        description: 'Description',
    },
    field: {
        location: 'Location',
        description: 'Description',
        suggestion: 'Suggestion',
        oldContent: 'Original',
        newContent: 'Revised',
        source: 'Source',
    },
    section: {
        abstract: 'Abstract',
        claims: 'Claims',
        title: 'Title',
        specification: 'Specification',
    },
    taskRunning: 'A task is currently running. Please wait for it to finish before starting a new review.',
    newReview: 'New Review',
    selectDocument: 'Select Document',
    noDocuments: 'No documents',
    reviewPrompt: 'Use the patent review tool to review',
    backToList: 'Back',
    startReview: 'Review',
    words: 'words',
    tab: {
        review: 'Review',
        rules: 'Rules',
    },
    customRules: {
        loadFailed: 'Failed to load rules',
        createSuccess: 'Rule created',
        createFailed: 'Failed to create rule',
        updateSuccess: 'Rule updated',
        updateFailed: 'Failed to update rule',
        deleteSuccess: 'Rule deleted',
        deleteFailed: 'Failed to delete rule',
        create: 'New Rule',
        searchPlaceholder: 'Search rules...',
        edit: 'Edit',
        delete: 'Delete',
        deleteConfirm: 'Delete this rule?',
        confirmYes: 'Confirm',
        confirmNo: 'Cancel',
        empty: 'No custom rules yet',
        systemEmpty: 'No system rules',
        systemBadge: 'System',
        viewMy: 'My Rules',
        viewSystem: 'System Rules',
        col: {
            ruleId: 'Rule ID',
            patentOffice: 'Office',
            category: 'Category',
            severity: 'Severity',
            description: 'Description',
            message: 'Message',
            status: 'Status',
            createdAt: 'Created',
            actions: 'Actions',
        },
        filter: {
            patentOffice: 'Office',
            category: 'Category',
            status: 'Status',
            enabled: 'Enabled',
            disabled: 'Disabled',
        },
        category: {
            claims: 'Claims',
            abstract: 'Abstract',
            title: 'Title',
            specification: 'Specification',
            drawing_description: 'Drawing Description',
            invention_content: 'Invention Content',
            field: 'Technical Field',
            punctuation: 'Punctuation',
            implementation: 'Detailed Description',
            background: 'Background',
            figures: 'Figures',
        },
        severity: {
            error: 'Error',
            warning: 'Warning',
            info: 'Info',
        },
        field: {
            patentOffice: 'Patent Office',
            category: 'Category',
            severity: 'Severity',
            description: 'Description',
            descriptionPlaceholder: 'e.g. Background section should objectively describe prior art',
            message: 'Message',
            messagePlaceholder: 'e.g. Background description does not meet requirements',
            suggestion: 'Suggestion',
            suggestionPlaceholder: 'e.g. Objectively describe prior art and identify the technical problem to be solved',
            requirement: 'Requirements',
            requirementPlaceholder: 'e.g.\nDescribe prior art useful for understanding, searching, and examining the invention\nObjectively identify problems and drawbacks in the prior art\nOnly point out problems the invention aims to solve',
            requirementHint: 'One requirement per line',
        },
        drawer: {
            titleCreate: 'New Rule',
            titleEdit: 'Edit Rule',
            cancel: 'Cancel',
            submit: 'Save',
            submitting: 'Saving...',
        },
        validation: {
            required: 'This field is required',
        },
    },
};
